export default __webpack_public_path__ + "static/media/dex-right-close.233b9bcc.png";